export function Input(props){
    return (
      <input
        {...props}
        className={`w-full rounded-lg border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:border-brand-600 focus:ring-1 focus:ring-brand-600 ${props.className||''}`}
      />
    );
  }
  export function Textarea(props){
    return (
      <textarea
        {...props}
        className={`w-full rounded-lg border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:border-brand-600 focus:ring-1 focus:ring-brand-600 ${props.className||''}`}
      />
    );
  }
  